<template>
  <div id="app">
    <Layout />
  </div>
</template>


<script>
import Layout from '@/layouts/Base';

export default {
  name: 'app',
  components: { Layout },
}
</script>

<style>
  .rouble-sign {
    font-family: 'PT Sans';
    font-style: normal;
  }
  .form-control--error {
    border-width: 2px !important;
  }

  @media screen and (max-width: 900px) {
    .checkout {
      padding-bottom: 40px !important;
    }
    .checkout__button {
      position: fixed;
      padding-bottom: 0;
      background-color: #fff;
      bottom: 0;
      left: 0;
      margin-top: 0;
      width: 100%;
      z-index: 10000;
      margin-top: 0 !important;
      background-color: #fff;
      padding: 15px;
    }
    .catalog-date__button {
      position: fixed;
      padding-bottom: 0;
      background-color: #fff;
      bottom: 0;
      left: 0;
      margin-top: 0;
      width: 100%;
      z-index: 10000;
      margin-top: 0 !important;
      background-color: #fff;
      padding: 15px !important;
    }
    .catalog-date {
      padding-bottom: 40px;
    }
  }
  .ladda-button{padding: 0!important;font-size: 16px !important;}
  .ladda-label{font-size: 16px !important;}
</style>